import React, { useEffect, useState } from "react";
import cssClasses from "./CancellationsAndRefundsModal.module.css";
import Close from "../../Components/Icons/Close";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import Datagrid from "../../Subcomponents/Datagrid";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { v4 as uuidv4 } from "uuid";
import UnitDetailsModal from "../../Modals/UnitDetailsModal/UnitDetailsModal";
import { useSelector } from "react-redux";



function CancellationsAndRefundsModal({ data, open, closeHandler}) {
 

const loggedInUser = useSelector((state) => state.Auth.user);
const [unitDetails, setUnitDetails] = useState({});
const [showUnitDetailsModal, setShowUnitDetailsModal] = useState(false);



  
useEffect(() => {


}, []);

  function openInNewIcon(row) {

    const findData = data?.find(
      (el) => el?.cancelUnitRequestId === row?.id
    );

    setUnitDetails(findData);
    setShowUnitDetailsModal(true);
  }

  function convertId(idString) {

    const year = idString.slice(0, 4);
    const month = idString.slice(4, 6);
    const day = idString.slice(6, 8);
    const sequence = idString.slice(8);

    const formattedId = `VJ${year}${month}${day}-${sequence}`;

    return formattedId;
  }

const allotmentHeader = [
    {
      field: "salesPerson",
      headerName: "Sales Person",
      width: 250,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-word" }}>
            {params.row?.salesPerson}
          </div>
        );
      },
    },
    {
      field: "leadname",
      headerName: "Lead Name",
      width: 400,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              width: "100%",
            }}
          >
            <div style={{  display: "flex", flexDirection: "column",  gap: "0.5rem",  wordBreak: "break-word" }}>
<div>
{params.row?.leadname?.personId?.name || ""}
    </div> 
    
    <div style={{ opacity: "0.7" }}>
              {params.row?.leadname?.leadDisplayId && convertId(params.row?.leadname?.leadDisplayId)}
        </div>          
        
          </div>
            {params.row?.leadname && (
              <InfoOutlinedIcon
                style={{ marginLeft: "4px", cursor: "pointer" }}
                onClick={() => openInNewIcon(params.row)}
              />
            )}
          </div>
        );
      },
    },
    {
      field: "unitCost",
      headerName: "Unit Cost",
      width: 200,
      renderCell: (params) => {
        const value = params.row?.unitCost || 0;
        return <div className={cssClasses.rupee}>{formatNumber(value)}</div>;
      },
    },
    {
      field: "paidAmount",
      headerName: "Paid Amount",
      width: 200,
      renderCell: (params) => {
        const value = params.row?.paidAmount || 0;
        return <div className={cssClasses.rupee}>{formatNumber(value)}</div>;
      },
    },
    {
      field: "cancellationCharges",
      headerName: "Cancellation Charges",
      width: 230,
      renderCell: (params) => {
        const value = params.row?.cancellationCharges || 0;
        return <div className={cssClasses.rupee}>{formatNumber(value)}</div>;
      },
    },

    {
      field: "refundAmount",
      headerName: "Refund Amount",
      width: 200,
      renderCell: (params) => {
        const value = params.row?.refundAmount || 0;
        return <div className={cssClasses.rupee}>{formatNumber(value)}</div>;
      },
    },
    {
      field: "cancellationStatus",
      headerName: "Cancellation Status",
      width: 220,
      renderCell: (params) => {
        return (
          <>
            {" "}
            {params.row.cancellationStatus && (
              <LeadStatusChip
                label={params.row.cancellationStatus}
                style={
                  params.row.cancellationStatus === "Accepted"
                    ? { color: "#027A48", backgroundColor: "#ECFDF3" }
                    : { color: "#B54708", backgroundColor: "#FFFAEB" }
                }
                icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
              />
            )}
          </>
        );
      },
    },
    {
      field: "refundStatus",
      headerName: "Refund Status",
      width: 250,
      renderCell: (params) => {
        return (
          <>
            { 
        params.row?.refundStatus !== ""  &&  (
              <LeadStatusChip
                label={
                  params.row?.refundStatus?.status === "Accepted" ? 
  (params.row?.refundStatus?.allotmentPaymentId?.status?.toLowerCase() === "refund initiated" ? 
    "Refund Initiated" : 
    (params.row?.refundStatus?.allotmentPaymentId?.status?.toLowerCase() === "refund processed" ? 
      "refund processed" : 
      params.row?.refundStatus?.allotmentPaymentId?.status
    )
  ) : 
  "No Refund Raised"
                }
                style={
                  (params.row?.refundStatus?.allotmentPaymentId?.status?.toLowerCase() ===
                  "refund initiated" || params.row?.refundStatus?.allotmentPaymentId?.status?.toLowerCase() ===
                  "payment complete" )
                    ? { color: "#027A48", backgroundColor: "#ECFDF3" }
                    : params.row?.refundStatus?.allotmentPaymentId?.status?.toLowerCase() ===
                      "refund processed"
                    ? { color: "#B54708", backgroundColor: "#FFFAEB" }
                    :{ color: "#B42318", backgroundColor: "#FEF3F2" }
                }
                icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
              />
            ) }
          </>
        );
      },
    },
  ];

function formatNumber(value) {
    if (value >= 10000000) {
      const croreValue = (value / 10000000).toFixed(2);
      return `${croreValue} Cr.`;
    } else {
      const formattedValue = new Intl.NumberFormat("en-IN").format(value);
      return formattedValue;
    }
  }

  const unitCostTotal = data?.reduce(
    (acc, curr) => (curr?.allotmentPaymentId?.unitCost?.total ?? 0) + acc,
    0
  );

  const cancellationChargeTotal = data?.reduce(
    (acc, curr) => (curr?.cancellationCharges ?? 0) + acc,
    0
  );


  const totalAllotmentRefund = () => {
    let sum = 0;
    for (let i = 0; i < data.length; i++) {
      const refundInitiated = data[
        i
      ]?.allotmentPaymentId?.AllotmentTransactions?.filter(
        (el) => el?.status?.toLowerCase() === "refund initiated"
      )?.reduce((acc, cur) => acc + cur.amount, 0);

      const refundProcessed = data[
        i
      ]?.allotmentPaymentId?.AllotmentTransactions?.filter(
        (el) => el?.status?.toLowerCase() === "refund processed"
      )?.reduce((acc, cur) => acc + cur.amount, 0);

      const refundAmount =
        data[i]?.allotmentPaymentId?.status === "Refund Initiated"
          ? refundInitiated
          : data[i]?.allotmentPaymentId?.status === "Refund Processed"
          ? refundProcessed
          : 0;

          if (data[i].status === "Accepted") {
            sum = sum + refundAmount;
          } else {
            sum = sum + 0;
          }
    }
    return sum;
  };



      const modifiedRefundAmount = [];

      for (let i = 0; i < data.length; i++) {
        const refundInitiated = data[
          i
        ]?.allotmentPaymentId?.AllotmentTransactions?.filter(
          (el) => el?.status?.toLowerCase() === "refund initiated"
        )?.reduce((acc, cur) => acc + cur.amount, 0);

        const refundProcessed = data[
          i
        ]?.allotmentPaymentId?.AllotmentTransactions?.filter(
          (el) => el?.status?.toLowerCase() === "refund processed"
        )?.reduce((acc, cur) => acc + cur.amount, 0);

        const refundAmount =
          data[i]?.allotmentPaymentId?.status === "Refund Initiated"
            ? refundInitiated
            : data[i]?.allotmentPaymentId?.status ===
              "Refund Processed"
            ? refundProcessed
            : 0;
        if (data[i].status === "Accepted") {
          modifiedRefundAmount.push({
            ...data[i],
            ...{ refundAmount: refundAmount },
          });
        } else {
          modifiedRefundAmount.push({
            ...data[i],
            ...{ refundAmount: 0 },
          });
        }
      }


      const transformedRows = modifiedRefundAmount?.map((allotment) => ({
        id: allotment?.cancelUnitRequestId,
        salesPerson: allotment.leadId?.userId?.name || "-",
        leadname: allotment.leadId || "-",
        unitCost: allotment.allotmentPaymentId?.unitCost?.total
          ? allotment.allotmentPaymentId?.unitCost?.total
          : 0,
        paidAmount: allotment.allotmentPaymentId?.paidAmount
          ? allotment.allotmentPaymentId?.paidAmount
          : 0,
        cancellationCharges: allotment?.cancellationCharges
          ? allotment?.cancellationCharges
          : 0,
        refundAmount: allotment?.refundAmount ? allotment?.refundAmount: 0,
        cancellationStatus: allotment?.status || "",
        refundStatus: allotment || "",
      }));

console.log("transformedRows", transformedRows)

      const sortedArray = [...transformedRows].sort(
        (a, b) => b?.last_updated_at - a?.last_updated_at
      );


      function calculateTotal(startIndex, endIndex, array) {
        let id = uuidv4();

        let subtotalUnitCost = 0;
        let subtotalPaidAmount = 0;
      let subtotalCancellationCharges = 0;
      let subtotalRefundAmount = 0;

        for (let i = startIndex; i <= endIndex; i++) {
          subtotalUnitCost += array[i]?.unitCost || 0;
          subtotalPaidAmount += array[i]?.paidAmount || 0;
          subtotalCancellationCharges += array[i]?.cancellationCharges || 0
          subtotalRefundAmount += array[i]?.refundAmount || 0;

    
        }


        return {
            id: id,
            salesPerson: "Sub total",
            leadname: "",
            cancellationStatus:  "",
            paidAmount: subtotalPaidAmount ? subtotalPaidAmount : "",
            refundAmount:  subtotalRefundAmount? subtotalRefundAmount:"",
            unitCost: subtotalUnitCost? subtotalUnitCost : "",
            cancellationCharges: subtotalCancellationCharges ? subtotalCancellationCharges: "",
            refundStatus: ""
     
        };
      }
      
      function addObjectsWithTotals(array, chunkSize) {
        let newArray = [];
      
        for (let i = 0; i < array.length; i += chunkSize) {
          let endIndex = i + chunkSize - 1;
          if (endIndex >= array.length) {
            endIndex = array.length - 1;
          }
      
          newArray = newArray.concat(array.slice(i, endIndex + 1));
      
          newArray.push(calculateTotal(i, endIndex, array));
        }
      
        return newArray;
      }
      
      let newArray = addObjectsWithTotals(sortedArray, 10);
      



  return (
    <>
      <Modal
        open={open}
        onClose={closeHandler}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={cssClasses.container}>
            <div style={{ margin: "1rem" }}>
            <div className={cssClasses.header} style={{ marginBottom: "1rem" }}>
            <p className={cssClasses.heading}>{data[0]?.allotmentPaymentId?.unitId?.projectId?.projectName}</p>
            <Box
                    ml={"auto"}
                    mt={1}
                    onClick={closeHandler}
                    style={{ cursor: "pointer" }}
                  >
                    <Close width={"1.2rem"} height={"1.2rem"} />
                  </Box>
          </div>
          <div className={cssClasses.totalPrice}>
            <div className={cssClasses.totalHeader}>
              <h1>Total</h1>
            </div>
            <div className={cssClasses.totalAmount}>
              <p className={cssClasses.priceTextHeader}>Unit Cost</p>
              <p className={cssClasses.priceText}>
                {formatNumber(unitCostTotal)}
              </p>
            </div>
            <hr />
            <div className={cssClasses.totalAmount}>
              <p className={cssClasses.priceTextHeader}>Cancellation Charges</p>
              <p className={cssClasses.priceText}>
                {formatNumber(cancellationChargeTotal)}
              </p>
            </div>
            <hr />
            <div className={cssClasses.totalAmount}>
              <p className={cssClasses.priceTextHeader}>Refund Amount</p>
              <p className={cssClasses.priceText}>
                {formatNumber(totalAllotmentRefund())}
              </p>
            </div>
          </div>
            </div>
        
          <div
           className={cssClasses.gridWrapper}
           style={{ margin: "1rem" }}
          >
     <Datagrid
                pageChanged={0}
                hideFooter={false}
                columns={(loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) ? allotmentHeader : allotmentHeader.filter(v => v?.field !== "salesPerson")}
                rows={ newArray}
                CancellationsAndRefunds={11}
                style={{
                  ".MuiDataGrid-virtualScrollerRenderZone > div:last-of-type": {
                    backgroundColor: "#f9fafb",
                    fontWeight: "600",
                    color: "#707b9a",
                    fontSize: "1.8rem",
                    position: "sticky",
                    bottom: "0",
                    borderTop: "1px solid lightGrey",
                    boxShadow: "1px 1px 1px 1px rgba(0,0,0,0.3)",
                  },
                }}
              />
        
          </div>
        </div>
      </Modal>
      {
        showUnitDetailsModal &&  (
            <UnitDetailsModal
              data={unitDetails}
              alloted={unitDetails?.allotmentPaymentId?.unitId?.created_at}
              open={showUnitDetailsModal}
              closeHandler={() => setShowUnitDetailsModal(false)}
            />
          )
      }
    </>
  );
}

export default CancellationsAndRefundsModal;
